import { gql } from '@apollo/client'

// Sliding 30-minute window: readings in progress, Starting but not stale, or
// Scheduled and starting before $upcomingCutoff.
export default gql`
  subscription GetLiveMonitorReadings(
    $upcomingCutoff: timestamptz!
    $staleCutoff: timestamptz!
  ) {
    reading(
      where: {
        _or: [
          { readingEventStatusName: { _in: ["In Progress", "Ending"] } }
          {
            _and: [
              { readingEventStatusName: { _eq: "Starting" } }
              { readingstart: { _gte: $staleCutoff } }
            ]
          }
          {
            _and: [
              { readingEventStatusName: { _eq: "Scheduled" } }
              { readingstart: { _lte: $upcomingCutoff } }
              { readingstart: { _gte: "now()" } }
            ]
          }
        ]
      }
      order_by: { readingstart: asc }
    ) {
      id
      readingstart
      readingEventStatusName
      topicName
      maxreaders
      seats_available
      duration {
        minutes
      }
      country {
        isocode
      }
      readingevents(
        where: { readingstate: { name: { _eq: "In Progress" } } }
        order_by: { created: asc }
        limit: 1
      ) {
        created
      }
      book {
        user_id
        user {
          person {
            name
          }
        }
      }
    }
  }
`
